module.exports = __webpack_public_path__ + "img/video-bones.42e9c31c.jpg";